export const OPEN_EDIT_MEDIA_DIALOG = 'dialogs/OPEN_EDIT_MEDIA_DIALOG';
export const CLOSE_EDIT_MEDIA_DIALOG = 'dialogs/CLOSE_EDIT_MEDIA_DIALOG';

export const OPEN_PREVIEW_MEDIA_DIALOG = 'auth/OPEN_PREVIEW_MEDIA_DIALOG';
export const CLOSE_PREVIEW_MEDIA_DIALOG = 'auth/CLOSE_PREVIEW_MEDIA_DIALOG';

export const OPEN_LOGIN_DIALOG = 'auth/OPEN_LOGIN_DIALOG';
export const CLOSE_LOGIN_DIALOG = 'auth/CLOSE_LOGIN_DIALOG';

export const OPEN_RESET_PASSWORD_DIALOG = 'auth/OPEN_RESET_PASSWORD_DIALOG';
export const CLOSE_RESET_PASSWORD_DIALOG = 'auth/CLOSE_RESET_PASSWORD_DIALOG';
